module.exports = __webpack_public_path__ + "static/media/en.ced16e99.svg";